import { antdThemeValues } from './antd-theme-values';

const {
  primary,
  secondary,
  error,
  borderLight,
  disabledBackground,
  disabledColor,
  white,
  borderRadiusBase,
  borderRadiusLarge,
  checkboxBorderRadius,
} = antdThemeValues;

export const antdTheme = {
  token: {
    colorPrimary: primary,
    colorSuccess: secondary,
    colorError: error,
    colorBorder: borderLight,
    colorBgLayout: white,
    colorBgContainer: white,
    colorBgContainerDisabled: disabledBackground,
    colorTextDisabled: disabledColor,
    borderRadius: borderRadiusBase,
    borderRadiusSM: borderRadiusBase,
    borderRadiusLG: borderRadiusLarge,
  },
  components: {
    Button: {
      colorPrimary: secondary,
      colorPrimaryHover: secondary,
      colorPrimaryActive: secondary,
      borderRadius: borderRadiusBase,
    },
    Checkbox: {
      borderRadiusSM: checkboxBorderRadius,
    },
    Collapse: {
      borderRadiusLG: borderRadiusLarge,
      headerBg: white,
    },
    Layout: {
      bodyBg: white,
      headerBg: white,
    },
    Menu: {
      itemSelectedBg: primary,
      itemBorderRadius: 4,
      subMenuItemBorderRadius: borderRadiusBase,
    },
    Radio: {
      buttonSolidCheckedBg: secondary,
      buttonSolidCheckedHoverBg: secondary,
      buttonSolidCheckedActiveBg: secondary,
    },
    Table: {
      borderRadius: borderRadiusLarge,
    },
  },
};
